define(['lodash',
    'localSiteSerializer/utils/deepSort'
], function (_, deepSort) {
    'use strict';

    const PAGES_CONTAINER_FIXED_HEIGHT = 400;

    const normalizePageContainerAndFooter = masterPageStructure => {
        const pagesContainerIndex = _.findIndex(masterPageStructure.children, {id: 'PAGES_CONTAINER'});
        const footerIndex = _.findIndex(masterPageStructure.children, {id: 'SITE_FOOTER'});
        const sitePagesIndex = _.findIndex(masterPageStructure.children[pagesContainerIndex].components, {id: 'SITE_PAGES'});
        const pagesContainerY = _.get(masterPageStructure, `children[${pagesContainerIndex}].layout.y`);

        _.set(masterPageStructure, `children[${pagesContainerIndex}].layout.height`, PAGES_CONTAINER_FIXED_HEIGHT); // eslint-disable-line santa/no-side-effects
        _.set(masterPageStructure, `children[${footerIndex}].layout.y`, PAGES_CONTAINER_FIXED_HEIGHT + pagesContainerY); // eslint-disable-line santa/no-side-effects
        _.set(masterPageStructure, `children[${pagesContainerIndex}].components[${sitePagesIndex}].layout.height`, PAGES_CONTAINER_FIXED_HEIGHT); // eslint-disable-line santa/no-side-effects

        return masterPageStructure;
    };

    const preserveComponentStyles = masterPageData => {
        const nonComponentsStyles = _.omitBy(masterPageData.theme_data, {type: 'ComponentStyle'});

        _.forEach(nonComponentsStyles, (style, styleId) => {
            _.unset(masterPageData.theme_data, styleId);
        });

        return masterPageData;
    };

    return {
        serialize: ({pagesData}) => {
            const masterPageData = pagesData.masterPage.data;

            _.unset(pagesData.masterPage, 'data');

            return {
                site: {
                    commonComponents: {
                        structure: deepSort(normalizePageContainerAndFooter(pagesData.masterPage.structure)),
                        data: preserveComponentStyles(masterPageData)
                    }
                }
            };
        },
        deserialize: payload => ({
            pagesData: {
                masterPage: payload.site.commonComponents
            }
        }),
        getEncryptedPaths: () => ['site.commonComponents']
    };
});
